import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Form-group validator: the two fields must be either both filled or both empty.
 * (e.g. an activity start/end time pair)
 */
export function bothOrNoneFieldsValidator(field1: string, field2: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const control1 = group.get(field1);
    const control2 = group.get(field2);

    if (!control1 || !control2) {
      return null; // One of the controls doesn't exist
    }

    const hasValue1 = control1.value != null && control1.value !== '';
    const hasValue2 = control2.value != null && control2.value !== '';

    if (hasValue1 === hasValue2) {
      return null; // Valid: both filled or both empty
    }

    return { bothOrNoneRequired: { fields: [field1, field2] } };
  };
}
